module.exports = __webpack_public_path__ + "img/beachtennisWhite.40b8c7d7.svg";